import { apiClient } from './apiClient';

import type { ApiResponse } from '@/types/auth.types';
import type {
  NotificationTemplate,
  NotificationTemplatePreview,
  PreviewTemplateData,
  TestSendData,
  UpdateTemplateData,
} from '@/types/notificationTemplate.types';

interface TemplateListData {
  items: NotificationTemplate[];
}

interface TemplateListParams {
  eventType?: string;
  channel?: string;
  language?: string;
}

export async function listTemplates(params?: TemplateListParams): Promise<NotificationTemplate[]> {
  const searchParams = new URLSearchParams();
  if (params?.eventType) searchParams.set('eventType', params.eventType);
  if (params?.channel) searchParams.set('channel', params.channel);
  if (params?.language) searchParams.set('language', params.language);
  const query = searchParams.toString();
  const url = query ? `/notifications/templates?${query}` : '/notifications/templates';
  const response = await apiClient.get<ApiResponse<TemplateListData>>(url);
  return response.data.items;
}

export async function getTemplate(id: string): Promise<NotificationTemplate> {
  const response = await apiClient.get<ApiResponse<NotificationTemplate>>(`/notifications/templates/${id}`);
  return response.data;
}

export async function updateTemplate(id: string, data: UpdateTemplateData): Promise<NotificationTemplate> {
  const response = await apiClient.put<ApiResponse<NotificationTemplate>>(`/notifications/templates/${id}`, data);
  return response.data;
}

export async function previewTemplate(id: string, data: PreviewTemplateData): Promise<NotificationTemplatePreview> {
  const response = await apiClient.post<ApiResponse<NotificationTemplatePreview>>(
    `/notifications/templates/${id}/preview`,
    data,
  );
  return response.data;
}

export async function testSendTemplate(id: string, data: TestSendData): Promise<void> {
  await apiClient.post(`/notifications/templates/${id}/test-send`, data);
}
